<div class="calendar-field-container">
  <label class="calendar-label" *ngIf="label">
    {{ label }}<span class="required-asterisk" *ngIf="required">*</span>
  </label>
  
  <mat-form-field appearance="outline" class="calendar-form-field" [class.error]="hasError" [class.has-selected-date]="hasSelectedDate">
    <input 
      #dateInput
      matInput 
      [matDatepicker]="picker"
      [min]="minDate"
      [max]="maxDate"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [(ngModel)]="value"
      (ngModelChange)="onDateChange($event)"
      (input)="onManualInput($event)"
      (keydown)="onKeyDown($event)">
    
    <mat-datepicker-toggle matIconSuffix [for]="picker">
      <mat-icon matDatepickerToggleIcon>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
        </svg>
      </mat-icon>
    </mat-datepicker-toggle>
    
    <mat-datepicker #picker></mat-datepicker>
    
    <mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>
    <mat-error *ngIf="!errorMessage && internalErrorMessage">{{ internalErrorMessage }}</mat-error>
  </mat-form-field>
</div>
